import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const surveyService = {
  unlockOfficerData: async (id) => {
    const response = await axiosInstance.get(`/survey/${id}/officer/unlock`)
    return response.data
  },
  lockOfficerData: async (id) => {
    const response = await axiosInstance.get(`/survey/${id}/officer/lock`)
    return response.data
  },
  getOfficerLockedData: async (params = {}) => {
    const response = await axiosInstance.get(`/survey/officer/list`, { params })
    return response.data
  },
  getNeedValidatingData: async (params = {}) => {
    const response = await axiosInstance.get('/survey/need-validating', { params })
    return response.data
  },
  getOfficerCheckingData: async (params = {}) => {
    const response = await axiosInstance.get('/survey/officer-checking', { params })
    return response.data
  },
  getRejectedData: async (params = {}) => {
    const response = await axiosInstance.get('/survey/rejected', { params })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/survey/' + id)
    return response.data
  },
  getRejectedDataById: async (id) => {
    const response = await axiosInstance.get(`/survey/${id}/rejected`)
    return response.data
  },
  getFinishDataById: async (id) => {
    const response = await axiosInstance.get(`/survey/${id}/finish`)
    return response.data
  },
  getOfficerCheckingDataById: async (id) => {
    const response = await axiosInstance.get(`/survey/${id}/officer-checking`)
    return response.data
  },
  create: async (data) => {
    const response = await axiosInstance.post(`/survey`, data)
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/survey/${data.id}`, data)
    return response.data
  },
  updateInstallation: async (data) => {
    const response = await axiosInstance.put(`/survey/${data.id}/installation`, data)
    return response.data
  },
  reject: async (data) => {
    const response = await axiosInstance.post(`/survey/${data.id}/reject`, data)
    return response.data
  },
  acceptSurvey: async (id, data) => {
    const response = await axiosInstance.post(`/survey/${id}/accept`, data)
    return response.data
  },
  finishSurvey: async (id) => {
    const response = await axiosInstance.post(`/survey/${id}/finish-survey`)
    return response.data
  },
  changeDocument: async (id, body) => {
    const response = await axiosInstance.putForm(`/survey/${id}/change-document`, body)
    return response.data
  },
  uploadServiceLetter: async (id, body) => {
    const response = await axiosInstance.postForm(`/survey/${id}/service-letter`, body)
    return response.data
  },
  uploadAdditionalLetter: async (id, body) => {
    const response = await axiosInstance.postForm(`/survey/${id}/additional-letter`, body)
    return response.data
  },
  uploadRccDocument: async (id, body) => {
    const response = await axiosInstance.postForm(`/survey/${id}/rcc-document`, body)
    return response.data
  },
  uploadCustomerImage: async (id, body) => {
    const response = await axiosInstance.postForm(`/survey/${id}/customer-image`, body)
    return response.data
  },
  deleteFile: async (id, letterId) => {
    const response = await axiosInstance.delete(`/survey/${id}/letter/${letterId}`)
    return response.data
  },
}